import { render, staticRenderFns } from "./DeviceDetailRowItem.vue?vue&type=template&id=55a0e6b0&scoped=true&"
import script from "./DeviceDetailRowItem.vue?vue&type=script&lang=js&"
export * from "./DeviceDetailRowItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a0e6b0",
  null
  
)

export default component.exports